import { localize } from 'commons/LocalizedText/LocalizedText';
import { generateRow } from 'utils/helpers/RowHelper';
import Tooltip from '@material-ui/core/Tooltip';

export const mailOrLoginRow = generateRow({
  label: 'contactMailOrLogin',
  name: 'mailOrLogin',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {row.mailOrLogin}
    </div>
  )
});

export const lastnameRow = generateRow({
  label: 'contactLastname',
  name: 'lastname',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {row.lastname}
    </div>
  )
});

export const firstnameRow = generateRow({
  label: 'contactFirstname',
  name: 'firstname',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {row.firstname}
    </div>
  )
});

export const companyRow = generateRow({
  label: 'contactCompany',
  name: 'company',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {row.company}
    </div>
  )
});

export const statusRow = generateRow({
  label: 'contactStatus',
  name: 'status',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {localize(row.status)}
    </div>
  )
});

export const profileRow = generateRow({
  label: 'contactProfile',
  name: 'profile',
  width: '10%',
  mobileWidth: '40%',
  isSortable: true,
  template: (row) => (
    <div>
      {localize(row.profile)}
    </div>
  )
});

export const programRow = generateRow({
  label: 'contactProgram',
  name: 'programList',
  width: '10%',
  mobileWidth: '40%',
  isSortable: false,
  template: (row) => {
    const programs = row.programList?.split(',') || [];
    const threshold = 3;
    const divider = ',';
    const programsString = (programs.length > threshold)
      ? programs.slice(0,threshold).join(divider) + '... +' + (programs.length - threshold)
      : programs.join(divider)

    return (
      <div>
        <Tooltip title={programs.join(divider)}>
          <p>{programsString}</p>
        </Tooltip>
      </div>
    )
  }
});